import React from "react";
import { fmtInt, POOL_TONE } from "@/lib/billing";

/* Segmented progress ring: included (solid) + purchased (lighter) over the monthly allotment. */
export default function CreditRing({ pool, label, backedBy, unit, included, purchased, allotment, size = 168 }) {
  const tone = POOL_TONE[pool] || POOL_TONE.scrape;
  const total = Math.max(0, included + purchased);
  const denom = Math.max(allotment || 1, total || 1);
  const r = (size - 18) / 2;
  const c = 2 * Math.PI * r;
  const incFrac = Math.min(1, Math.max(0, included) / denom);
  const purFrac = Math.min(1 - incFrac, Math.max(0, purchased) / denom);
  const negative = total < 0;

  return (
    <div className="flex flex-col items-center text-center" data-testid={`credit-ring-${pool}`}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} stroke="#F1F5F9" strokeWidth="14" fill="none" />
          <circle
            cx={size / 2} cy={size / 2} r={r} stroke={tone.soft} strokeWidth="14" fill="none"
            strokeDasharray={`${c * purFrac} ${c}`} strokeDashoffset={-c * incFrac}
            strokeLinecap="butt" className="transition-all duration-700"
          />
          <circle
            cx={size / 2} cy={size / 2} r={r} stroke={tone.ring} strokeWidth="14" fill="none"
            strokeDasharray={`${c * incFrac} ${c}`} strokeLinecap="butt" className="transition-all duration-700"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className={"text-3xl font-bold tabular-nums font-display " + (negative ? "text-rose-600" : "text-slate-900")} data-testid={`credit-total-${pool}`}>
            {fmtInt(total)}
          </div>
          <div className="text-[10px] uppercase tracking-wider text-slate-500">credits left</div>
        </div>
      </div>
      <div className="mt-3 text-sm font-semibold text-slate-900">{label}</div>
      <div className="text-[11px] text-slate-500">Backed by {backedBy} · {unit}</div>
      <div className="mt-2 flex items-center gap-3 text-[11px] text-slate-600 tabular-nums">
        <span className="inline-flex items-center gap-1"><i className="inline-block h-2 w-2 rounded-sm" style={{ background: tone.ring }} /> {fmtInt(included)} included</span>
        <span className="inline-flex items-center gap-1"><i className="inline-block h-2 w-2 rounded-sm" style={{ background: tone.soft }} /> {fmtInt(purchased)} purchased</span>
      </div>
      {negative ? <div className="mt-1 text-[11px] text-rose-600">Overshot — top up to run more</div> : null}
    </div>
  );
}
